import { Component, ojs, app, state, v } from "modular-openscriptjs";
import {
    inform,
    pageInfo,
    redirect,
    scrollToTop,
    dataURLtoBlob,
} from "../../../helpers";
import { api, dc, STRINGS } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";
import Spinner from "../../Blocks/Spinner";
import EditProductImageForm from "../../Forms/EditProductImageForm";
import CheckYesno from "../../Blocks/CheckYesno";
import { dom, tool } from "../../../fotastart";
import Cropper from "cropperjs";
import { $e } from "../../../ojs.events";

const h = app("h");

ojs(SolidIcon, Spinner, EditProductImageForm, CheckYesno);

export default class ManagePrimaryInfo extends Component {
    businessId = null;
    business = state(null);
    handleAvailable = state(true);
    debounceTimer = null;
    logo = state(null);
    uploadingLogo = state(false);
    cover = state(null);
    uploadingCover = state(false);
    cropper = { obj: null };
    customerShare = state(0);
    shouldGenerateOrderAudio = state(false);

    formData = {
        name: "",
        handle: "",
        description: "",
        location: "",
        commission_rate: 12,
        customer_commission_rate: 0,
        should_generate_order_audio: false,
    };

    render() {
        const router = app("router");
        this.businessId = router.params.companyId;
        scrollToTop();

        if (!this.business.value) {
            this.fetchBusiness();
        }

        return h.div(
            { class: "min-vh-100 py-4 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                h.div(
                    { class: "mb-4 d-flex align-items-center gap-3" },
                    h.button(
                        {
                            class: "btn btn-white border shadow-sm rounded-circle p-2",
                            onclick: "history.back()",
                        },
                        h.SolidIcon("arrow-left"),
                    ),
                    h.h2({ class: "fw-bold mb-0" }, "Primary Information"),
                ),

                v(this.business, (b) => {
                    if (!b.value)
                        return h.div(
                            { class: "text-center py-5" },
                            h.Spinner(),
                        );

                    return h.div(
                        { class: "card border-0 shadow-sm rounded-4" },
                        h.div(
                            { class: "card-body p-4" },
                            h.div(
                                { class: "row g-4" },
                                h.div(
                                    { class: "col-12 text-center" },
                                    h.div(
                                        {
                                            class: "position-relative d-inline-block rounded-circle bg-light border overflow-hidden",
                                            style: "width: 120px; height: 120px;",
                                        },
                                        v(this.logo, (l) =>
                                            h.img({
                                                src:
                                                    l.value ||
                                                    b.value.logo_path ||
                                                    "/assets/images/placeholder-business.png",
                                                class: "w-100 h-100 object-fit-cover",
                                                alt: "Business Logo",
                                            }),
                                        ),
                                        v(this.uploadingLogo, (u) =>
                                            u.value
                                                ? h.div(
                                                      {
                                                          class: "position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75",
                                                      },
                                                      h.Spinner(),
                                                  )
                                                : null,
                                        ),
                                    ),
                                    h.div(
                                        { class: "mt-2" },
                                        h.label(
                                            {
                                                class: "btn btn-sm btn-outline-primary rounded-pill",
                                            },
                                            "Change Logo",
                                            h.input({
                                                type: "file",
                                                class: "d-none",
                                                accept: "image/*",
                                                onchange: this.method(
                                                    "onLogoChange",
                                                    ["${this}"],
                                                ),
                                            }),
                                        ),
                                    ),
                                    h.div(
                                        { class: "mt-4 text-center" },
                                        h.div(
                                            {
                                                class: "small text-uppercase fw-bold text-muted mb-2",
                                            },
                                            "Cover Photo",
                                        ),
                                        h.div(
                                            {
                                                class: "position-relative d-inline-block w-100 rounded-4 bg-light border overflow-hidden shadow-sm",
                                                style: "max-width: 480px; aspect-ratio: 2 / 1;",
                                            },
                                            v(this.cover, (c) =>
                                                h.img({
                                                    src:
                                                        c.value ||
                                                        b.value.cover_image ||
                                                        "/assets/images/placeholder-business.png",
                                                    class: "w-100 h-100 object-fit-cover",
                                                    alt: "Business Cover Photo",
                                                }),
                                            ),
                                            v(this.uploadingCover, (uc) =>
                                                uc.value
                                                    ? h.div(
                                                          {
                                                              class: "position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75",
                                                          },
                                                          h.Spinner(),
                                                      )
                                                    : null,
                                            ),
                                        ),
                                        h.div(
                                            { class: "mt-2" },
                                            h.label(
                                                {
                                                    class: "btn btn-sm btn-outline-primary rounded-pill",
                                                },
                                                "Change Cover Photo",
                                                h.input({
                                                    type: "file",
                                                    class: "d-none",
                                                    accept: "image/*",
                                                    onchange: this.method(
                                                        "onCoverChange",
                                                        ["${this}"],
                                                    ),
                                                }),
                                            ),
                                        ),
                                    ),
                                ),
                                h.div(
                                    { class: "col-12" },
                                    h.label(
                                        {
                                            class: "form-label small text-uppercase fw-bold text-muted",
                                        },
                                        "Business Name",
                                    ),
                                    h.input({
                                        class: "form-control fs-3",
                                        value: b.value.name,
                                        listeners: {
                                            input: (e) =>
                                                (this.formData.name =
                                                    e.target.value),
                                        },
                                    }),
                                ),
                                h.div(
                                    { class: "col-12" },
                                    h.label(
                                        {
                                            class: "form-label small text-uppercase fw-bold text-primary",
                                        },
                                        "Business Handle",
                                    ),
                                    h.div(
                                        { class: "input-group" },
                                        h.span(
                                            {
                                                class: "input-group-text bg-light border-0 pe-0 text-muted",
                                            },
                                            "@",
                                        ),
                                        h.input({
                                            class: "form-control border-0",
                                            value:
                                                b.value.handle ||
                                                b.value.username,
                                            oninput: this.method(
                                                "checkHandleAvailability",
                                                ["${this}"],
                                            ),
                                            listeners: {
                                                input: (e) => {
                                                    e.target.value =
                                                        e.target.value
                                                            .toLowerCase()
                                                            .replace(
                                                                /[^a-z0-9._-]/g,
                                                                "",
                                                            );
                                                    this.formData.handle =
                                                        e.target.value;
                                                },
                                            },
                                        }),
                                        v(this.handleAvailable, (available) => {
                                            if (available.value === true) {
                                                return h.span(
                                                    {
                                                        class: "input-group-text bg-light border-0 text-success h-100",
                                                    },
                                                    h.i({
                                                        class: "bi bi-check-circle-fill",
                                                    }),
                                                );
                                            }
                                            if (available.value === false) {
                                                return h.span(
                                                    {
                                                        class: "input-group-text bg-light border-0 text-danger h-100",
                                                    },
                                                    h.i({
                                                        class: "bi bi-x-circle-fill",
                                                    }),
                                                );
                                            }
                                            if (
                                                available.value === "processing"
                                            ) {
                                                return h.Spinner({
                                                    class: "input-group-text bg-light border-0 h-100",
                                                });
                                            }
                                            return null;
                                        }),
                                    ),
                                ),
                                h.div(
                                    { class: "col-12" },
                                    h.label(
                                        {
                                            class: "form-label small text-uppercase fw-bold text-muted",
                                        },
                                        "Description",
                                    ),
                                    h.textarea(
                                        {
                                            class: "form-control fs-4",
                                            rows: 3,
                                            listeners: {
                                                input: (e) =>
                                                    (this.formData.description =
                                                        e.target.value),
                                            },
                                            placeholder: "We offer ...",
                                        },
                                        b.value.description,
                                    ),
                                ),
                                h.div(
                                    { class: "col-12" },
                                    h.label(
                                        {
                                            class: "form-label small text-uppercase fw-bold text-muted",
                                        },
                                        "Physical Address",
                                    ),
                                    h.input({
                                        class: "form-control fs-3",
                                        value: b.value.location ?? "",
                                        listeners: {
                                            input: (e) =>
                                                (this.formData.location =
                                                    e.target.value),
                                        },
                                        placeholder: "123 ABC Place, Nairobi",
                                    }),
                                ),
                                h.div(
                                    { class: "col-12 mt-3" },
                                    h.label(
                                        {
                                            class: "form-label fw-bold mb-3 small text-uppercase text-muted",
                                        },
                                        "Commission Split (Total 12%)",
                                    ),
                                    h.div(
                                        { class: "row g-3 mb-3" },
                                        h.div(
                                            { class: "col-6" },
                                            h.div(
                                                {
                                                    class: "card border shadow-sm text-center p-3 h-100 bg-white",
                                                    style: "border-radius: 12px;",
                                                },
                                                h.i({
                                                    class: "bi bi-person-fill text-warning fs-3 mb-1",
                                                }),
                                                h.div(
                                                    {
                                                        class: "text-muted small",
                                                    },
                                                    "Customer Pays",
                                                ),
                                                h.div(
                                                    {
                                                        class: "fw-bold fs-5 text-dark",
                                                    },
                                                    v(
                                                        this.customerShare,
                                                        (cs) => `${cs.value}%`,
                                                    ),
                                                ),
                                            ),
                                        ),
                                        h.div(
                                            { class: "col-6" },
                                            h.div(
                                                {
                                                    class: "card border shadow-sm text-center p-3 h-100 bg-white",
                                                    style: "border-radius: 12px;",
                                                },
                                                h.i({
                                                    class: "bi bi-briefcase-fill text-primary fs-3 mb-1",
                                                }),
                                                h.div(
                                                    {
                                                        class: "text-muted small",
                                                    },
                                                    "Business Pays",
                                                ),
                                                h.div(
                                                    {
                                                        class: "fw-bold fs-5 text-dark",
                                                    },
                                                    v(
                                                        this.customerShare,
                                                        (cs) =>
                                                            `${12 - cs.value}%`,
                                                    ),
                                                ),
                                            ),
                                        ),
                                    ),
                                    h.div(
                                        {
                                            class: "card border shadow-sm p-3 mb-3 bg-white",
                                            style: "border-radius: 12px;",
                                        },
                                        v(this.customerShare, (cs) => {
                                            const leftPct =
                                                (cs.value / 12) * 100;
                                            return h.div(
                                                {
                                                    class: "position-relative py-4 my-2 user-select-none ruler-track",
                                                    style: "cursor: pointer;",
                                                    onmousedown: this.method(
                                                        "startDrag",
                                                        ["${event}"],
                                                    ),
                                                    ontouchstart: this.method(
                                                        "startDrag",
                                                        ["${event}"],
                                                    ),
                                                },
                                                // Track line
                                                h.div({
                                                    class: "w-100 bg-secondary opacity-25 position-absolute start-0 end-0",
                                                    style: "height: 2px; top: 50%; transform: translateY(-50%);",
                                                }),
                                                // Ticks
                                                h.div(
                                                    {
                                                        class: "d-flex justify-content-between w-100 position-absolute start-0 end-0",
                                                        style: "top: 50%; transform: translateY(-50%); height: 16px; pointer-events: none;",
                                                    },
                                                    ...Array.from({
                                                        length: 13,
                                                    }).map((_, i) =>
                                                        h.div({
                                                            class: "border-start border-secondary opacity-50",
                                                            style: `height: ${i === 0 || i === 12 ? "16px" : "8px"}; transform: translateY(${i === 0 || i === 12 ? "-8px" : "-4px"});`,
                                                        }),
                                                    ),
                                                ),
                                                // Tick Labels
                                                h.div(
                                                    {
                                                        class: "d-flex justify-content-between w-100 position-absolute start-0 end-0 small text-muted",
                                                        style: "top: 70%; pointer-events: none; font-size: 10px;",
                                                    },
                                                    ...Array.from({
                                                        length: 13,
                                                    }).map((_, i) =>
                                                        h.span(
                                                            {
                                                                class: "text-center",
                                                                style: "width: 20px; margin-left: -10px; margin-right: -10px;",
                                                            },
                                                            `${i}%`,
                                                        ),
                                                    ),
                                                ),
                                                // Vertical Indicator Bar
                                                h.div({
                                                    class: "bg-primary position-absolute rounded",
                                                    style: `width: 4px; height: 32px; top: 50%; transform: translate(-50%, -50%); left: ${leftPct}%; transition: left 0.05s ease-out;`,
                                                }),
                                            );
                                        }),
                                    ),
                                    h.div(
                                        {
                                            class: "form-text small text-muted text-center mb-2",
                                        },
                                        "Slide to adjust commission split.",
                                    ),
                                    h.div(
                                        {
                                            class: "alert alert-info py-2 px-3 small d-flex align-items-start gap-2 mt-2",
                                            style: "border-radius: 8px; border: 1px solid rgba(13, 202, 240, 0.2);",
                                        },
                                        h.i({
                                            class: "bi bi-info-circle-fill text-info fs-6 mt-1",
                                        }),
                                        h.span(
                                            {},
                                            `Commission split applies to all prices above ${dc.userCurrency} 150. The higher the customer share, the higher your prices will be on the App.`,
                                        ),
                                    ),
                                ),
                                v(this.shouldGenerateOrderAudio, (s) => {
                                    return h.div(
                                        { class: "mb-3" },
                                        h.label(
                                            {
                                                class: "form-label fw-bold mb-2 small text-uppercase text-muted d-flex align-items-center gap-2",
                                            },
                                            h.i({
                                                class: "bi bi-stars text-primary",
                                            }),
                                            "AI Features",
                                        ),
                                        h.div(
                                            {
                                                class: "p-4 rounded-4 bg-white border position-relative overflow-hidden",
                                                style: "animation: rotatingGlow 4s linear infinite; transition: all 0.3s ease;",
                                            },
                                            h.style(`
                        @keyframes rotatingGlow {
                            0% {
                                box-shadow: 0 0 15px rgba(128, 0, 128, 0.6), inset 0 0 10px rgba(255, 215, 0, 0.2);
                                border-color: #800080;
                            }
                            25% {
                                box-shadow: 0 0 15px rgba(255, 215, 0, 0.6), inset 0 0 10px rgba(0, 123, 255, 0.2);
                                border-color: #ffd700;
                            }
                            50% {
                                box-shadow: 0 0 15px rgba(0, 123, 255, 0.6), inset 0 0 10px rgba(220, 53, 69, 0.2);
                                border-color: #007bff;
                            }
                            75% {
                                box-shadow: 0 0 15px rgba(220, 53, 69, 0.6), inset 0 0 10px rgba(128, 0, 128, 0.2);
                                border-color: #dc3545;
                            }
                            100% {
                                box-shadow: 0 0 15px rgba(128, 0, 128, 0.6), inset 0 0 10px rgba(255, 215, 0, 0.2);
                                border-color: #800080;
                            }
                        }
                    `),
                                            h.CheckYesno(
                                                {
                                                    id: "should_generate_order_audio",
                                                    checked: s?.value ?? false,
                                                    label: {
                                                        value: h.span(
                                                            h.BsIcon(
                                                                "volume-up-fill",
                                                                {
                                                                    class: "text-blue",
                                                                },
                                                            ),
                                                            h.span(
                                                                "Listen to Orders",
                                                            ),
                                                            {
                                                                class: "d-inline-flex gap-2 align-items-center",
                                                            },
                                                        ),
                                                        bolder: true,
                                                    },
                                                    helpText: {
                                                        value: "We will use your AI credits to generate the audio version of each order so that you can listen to what was ordered on the go.",
                                                        class: "text-secondary mt-1 d-block fw-normal",
                                                    },
                                                    onchange: this.method(
                                                        "setAudioGeneration",
                                                        ["${this}"],
                                                    ),
                                                },
                                                {
                                                    class: "check-yesno-end d-flex justify-content-between align-items-center w-100 m-0",
                                                },
                                            ),
                                        ),
                                    );
                                }),

                                h.div(
                                    { class: "col-12 text-end mt-4" },
                                    h.button(
                                        {
                                            class: "btn btn-primary px-3",
                                            onclick: this.method(
                                                "updateBusiness",
                                                ["${this}"],
                                            ),
                                        },
                                        "Save Changes",
                                    ),
                                ),
                            ),
                        ),
                    );
                }),
            ),
        );
    }

    async fetchBusiness() {
        try {
            const res = await api.get(`companies/${this.businessId}`);
            if (res) {
                this.business.value = res.data.company;
                this.formData.name = res.data.company.name;
                this.formData.handle = res.data.company.handle;
                this.formData.description = res.data.company.description;
                this.formData.location = res.data.company.location;
                this.formData.commission_rate =
                    res.data.company.commission_rate;
                this.formData.customer_commission_rate =
                    res.data.company.customer_commission_rate || 0;
                this.customerShare.value =
                    res.data.company.customer_commission_rate || 0;
                this.formData.should_generate_order_audio =
                    res.data.company.should_generate_order_audio ?? false;
                this.shouldGenerateOrderAudio.value =
                    res.data.company.should_generate_order_audio ?? false;
            }
        } catch (e) {
            inform("Failed to fetch business", STRINGS.ERROR);
        }
    }

    setAudioGeneration(elem) {
        this.shouldGenerateOrderAudio.value = elem.checked;
        this.formData.should_generate_order_audio = elem.checked;
    }

    startDrag(e) {
        e.preventDefault();
        const isTouch = e.type.startsWith("touch");
        const startX = isTouch ? e.touches[0].clientX : e.clientX;

        const track = e.currentTarget.classList.contains("ruler-track")
            ? e.currentTarget
            : e.currentTarget.closest(".ruler-track");
        if (!track) return;

        const rect = track.getBoundingClientRect();

        const updateVal = (clientX) => {
            let offset = clientX - rect.left;
            let pct = offset / rect.width;
            pct = Math.max(0, Math.min(1.0, pct)); // clamp between 0% and 100%

            const customerVal = Math.round(pct * 12);
            const val = 12 - customerVal;

            this.customerShare.value = customerVal;
            this.formData.customer_commission_rate = customerVal;
            this.formData.commission_rate = val;
        };

        updateVal(startX);

        const onMove = (moveEvent) => {
            const clientX = moveEvent.type.startsWith("touch")
                ? moveEvent.touches[0].clientX
                : moveEvent.clientX;
            updateVal(clientX);
        };

        const onEnd = () => {
            document.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseup", onEnd);
            document.removeEventListener("touchmove", onMove);
            document.removeEventListener("touchend", onEnd);
        };

        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onEnd);
        document.addEventListener("touchmove", onMove, { passive: true });
        document.addEventListener("touchend", onEnd);
    }

    checkHandleAvailability(target) {
        target.value = target.value.toLowerCase().replace(/[^a-z0-9._-]/g, "");
        const handle = target.value;
        this.handleAvailable.value = null;

        if (!handle || handle.length < 3) return;
        this.handleAvailable.value = "processing";

        if (this.debounceTimer) clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(async () => {
            try {
                const res = await api.get(`companies/check-availability`, {
                    handle: handle,
                    exclude_id: this.businessId,
                });
                if (res) {
                    this.handleAvailable.value = res.data.available;
                }
            } catch (e) {
                console.error(e);
            }
        }, 500);
    }

    onLogoChange(input) {
        const file = input.files[0];
        if (!file) return;

        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.addEventListener("load", () => {
            const src = fileReader.result;
            const options = new tool.ModalOptions();
            options.buttons.right.text = "Crop & Upload";
            options.buttons.left.text = "Cancel";
            options.classes.buttons.right = "btn btn-primary";
            options.classes.dialog = "modal-lg modal-fullscreen-md-down";
            options.staticBackdrop();

            const { buttons, modal } = tool.modal(
                "Crop Logo",
                h.EditProductImageForm(src),
                options,
            );

            modal.element.addEventListener("shown.bs.modal", () => {
                const preview = dom.id("epif-image-view");
                preview.classList.remove("d-none");

                this.cropper.obj = new Cropper(preview, {
                    aspectRatio: 1,
                    viewMode: 2,
                    minContainerHeight: 350,
                });
            });

            buttons.left.button.addEventListener("click", () => modal.close());

            buttons.right.button.addEventListener("click", () => {
                const cropData = this.cropper.obj.getData();
                const croppedSrc = this.cropper.obj
                    .getCroppedCanvas()
                    .toDataURL();
                this.uploadLogo(src, croppedSrc, cropData);
                modal.close();
            });
        });
    }

    async uploadLogo(originalSrc, croppedSrc, cropData) {
        this.uploadingLogo.value = true;
        try {
            const originalBlob = await dataURLtoBlob(originalSrc);
            const croppedBlob = await dataURLtoBlob(croppedSrc);

            const formData = new FormData();
            formData.append("image[original]", originalBlob);
            formData.append("image[cropped]", croppedBlob);
            formData.append("image[cropData][x]", cropData.x);
            formData.append("image[cropData][y]", cropData.y);
            formData.append("image[cropData][width]", cropData.width);
            formData.append("image[cropData][height]", cropData.height);

            const res = await api.post(
                `companies/${this.businessId}/logo`,
                formData,
                {
                    fetch_using: "browser",
                    "remove-content-type": true,
                },
            );

            if (res) {
                this.logo.value = res.data.logo_url;
                inform("Logo updated successfully!", STRINGS.SUCCESS);
            }
        } catch (e) {
            console.error(e);
            inform("Failed to upload logo", STRINGS.ERROR);
        } finally {
            this.uploadingLogo.value = false;
        }
    }

    onCoverChange(input) {
        const file = input.files[0];
        if (!file) return;

        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);

        fileReader.addEventListener("load", () => {
            const src = fileReader.result;
            const options = new tool.ModalOptions();
            options.buttons.right.text = "Crop & Upload";
            options.buttons.left.text = "Cancel";
            options.classes.buttons.right = "btn btn-primary";
            options.classes.dialog = "modal-lg modal-fullscreen-md-down";
            options.staticBackdrop();

            const { buttons, modal } = tool.modal(
                "Crop Cover Photo",
                h.EditProductImageForm(src),
                options,
            );

            modal.element.addEventListener("shown.bs.modal", () => {
                const preview = dom.id("epif-image-view");
                preview.classList.remove("d-none");

                this.cropper.obj = new Cropper(preview, {
                    aspectRatio: 2,
                    viewMode: 2,
                    minContainerHeight: 350,
                });
            });

            buttons.left.button.addEventListener("click", () => modal.close());

            buttons.right.button.addEventListener("click", () => {
                const cropData = this.cropper.obj.getData();
                const croppedSrc = this.cropper.obj
                    .getCroppedCanvas()
                    .toDataURL();
                this.uploadCover(src, croppedSrc, cropData);
                modal.close();
            });
        });
    }

    async uploadCover(originalSrc, croppedSrc, cropData) {
        this.uploadingCover.value = true;
        try {
            const originalBlob = await dataURLtoBlob(originalSrc);
            const croppedBlob = await dataURLtoBlob(croppedSrc);

            const formData = new FormData();
            formData.append("image[original]", originalBlob);
            formData.append("image[cropped]", croppedBlob);
            formData.append("image[cropData][x]", cropData.x);
            formData.append("image[cropData][y]", cropData.y);
            formData.append("image[cropData][width]", cropData.width);
            formData.append("image[cropData][height]", cropData.height);

            const res = await api.post(
                `companies/${this.businessId}/cover`,
                formData,
                {
                    fetch_using: "browser",
                    "remove-content-type": true,
                },
            );

            if (res) {
                this.cover.value = res.data.cover_url;
                inform("Cover photo updated successfully!", STRINGS.SUCCESS);
            }
        } catch (e) {
            console.error(e);
            inform("Failed to upload cover photo", STRINGS.ERROR);
        } finally {
            this.uploadingCover.value = false;
        }
    }

    async updateBusiness(btn) {
        if (!this.formData.name) {
            return inform("Please enter your business name.", "warning");
        }

        if (this.handleAvailable.value !== true) {
            return inform(
                "Please choose an available business handle.",
                "warning",
            );
        }

        if (!this.formData.description) {
            return inform("Please enter a business description.", "warning");
        }

        if (!this.formData.location) {
            return inform("Please enter a physical address.", "warning");
        }

        try {
            dom.disable(btn);
            h.Spinner({ parent: btn, resetParent: true });

            const res = await api.put(
                `companies/${this.businessId}`,
                this.formData,
            );

            if (res) {
                inform("Business information updated!", STRINGS.SUCCESS);
                app("broker").send($e.system.needs.configReload);
            }
        } catch (e) {
            inform("Failed to update business", STRINGS.ERROR);
        } finally {
            dom.enable(btn);
            h.span("Save Changes", { parent: btn, resetParent: true });
        }
    }
}

ojs(ManagePrimaryInfo);
